export default "__VITE_ASSET__nsIpsWIi__";